module.exports = __webpack_public_path__ + "img/cardioid_curve.af2aea41.png";